import React, { FC } from 'react';

import {
	NO_SYNCED_SESSIONS_MSG,
	NO_SYNCED_SESSIONS_TITLE,
	REPORT_NOT_FOUND_STATE_KEY
} from 'src/apps/mobile-common/consts/MobileCommonConsts';
import { ReportNotFoundPopup } from 'src/common/components/report-not-found-popup/ReportNotFoundPopup';

export const MfaSessionNotSyncedYetPopup: FC = () => {
	return (
		<ReportNotFoundPopup
			title={NO_SYNCED_SESSIONS_TITLE}
			text={NO_SYNCED_SESSIONS_MSG}
			stateKey={REPORT_NOT_FOUND_STATE_KEY}
		/>
	);
};
